<template>
  <div class="filter-container">
    <div class="general-search d-flex justify-between">
      <!-- 搜索输入框条件 -->
      <div class="filter-area d-flex justify-center">
        <el-select v-if="selectShow" v-model="selectValue" :placeholder="selectPlaceholder" style="padding-right:8px" @change="selectChange">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <div v-if="searchInput" :class="[isFocus ? 'position-relative search_div input_focus' : 'position-relative search_div']">
          <el-input
            ref="input"
            v-model="keyword"
            :placeholder="placeholder"
            :size="size"
            class="filter-item search-item search-input"
            clearable
            @keyup.enter.native="search"
            @input="getInput"
            @clear="clearInput"
            @focus="isFocus = true"
            @blur="isFocus = false"
          >
            <!-- 普通搜索 -->
            <!-- <el-button v-if="advancedContentShow" slot="append" icon="el-icon-search" /> -->
          </el-input>
          <!-- 普通搜索 -->
          <span v-if="!advancedContentShow || !advancedShow" class="position-absolute search-btn allow" @click="search"><i class="el-icon-search"></i></span>
          <span v-if="advancedContentShow && advancedShow" class="position-absolute search-btn disable" style="background-color: #f5f7fa;cursor: not-allowed;">
            <i class="el-icon-search"></i>
          </span>
        </div>
        <slot></slot>
        <el-date-picker
          v-if="datePickerShow"
          v-model="timeRange"
          style="margin-right: 24px;width: 325px;"
          :end-placeholder="this.$t('结束时间')"
          format="yyyy-MM-dd HH:mm"
          :start-placeholder="this.$t('开始时间')"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm"
          @change="deteRange"
        />
        <!-- 高级搜索 -->
        <el-button v-if="advancedShow" style="margin-left:10px !important" class="filter-item ml-1" :size="size" type="default" @click="advancedSearch">{{ $t('高级搜索') }}</el-button>
      </div>
      <!-- 操作 -->
      <div v-if="operaShow" class="opera-area d-flex">
        <!-- 类型拓展 -->
        <slot name="expand"></slot>
        <!-- 导出 -->
        <el-button v-if="exportShow" class="filter-item" :size="size" type="default" @click.native="exportExcel">{{ $t('导出') }}</el-button>
        <!-- 新增 -->
        <el-button v-if="addShow" class="filter-item" style="margin-right:0px" :size="size" type="primary" icon="el-icon-plus" @click.native="add">
          {{ $t('新增') }}
        </el-button>
      </div>
    </div>
    <!-- 高级搜索拓展 -->
    <div v-show="advancedContentShow" class="advanced-search" style="margin-top:6px"><slot name="advanced"></slot></div>
  </div>
</template>

<script>
export default {
  name: 'QuerySearch',
  props: {
    searchInput: {
      type: Boolean,
      default: true
    },
    // select选择器选项
    options: {
      type: Array,
      default() {
        return [];
      }
    },
    // select选择器提示文本
    selectPlaceholder: {
      type: String,
      default: ''
    },
    // 输入框占位文
    placeholder: {
      type: String,
      default: ''
    },
    // 尺寸大小
    size: {
      type: String,
      default: ''
    },
    // 是否显示datePicker选择器
    datePickerShow: {
      type: Boolean,
      default: false
    },
    // 是否显示select选择器
    selectShow: {
      type: Boolean,
      default: false
    },
    // 是否展开默认搜索栏
    isAdvancedContentShow: {
      type: Boolean,
      default: false
    },
    // 是否显示高级搜索按钮
    advancedShow: {
      type: Boolean,
      default: false
    },
    // 是否显示操作区域
    operaShow: {
      type: Boolean,
      default: true
    },
    // 是否显示导出按钮
    exportShow: {
      type: Boolean,
      default: true
    },
    // 是否显示新增按钮
    addShow: {
      type: Boolean,
      default: true
    },
    // 下拉选择器的默认值
    selectDefault: {
      type: String,
      default: ''
    },
    // 搜索输入框的默认值
    model: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isFocus: false,
      timeRange: '',
      selectValue: '',
      keyword: this.model,
      advancedContentShow: this.isAdvancedContentShow
    };
  },
  watch: {
    // 高级搜索里面存在与搜索输入框同一字段时，两者内容能一致
    model: {
      handler: function(val) {
        this.keyword = val;
      },
      immediate: true
    },
    selectDefault: {
      handler: function(val) {
        this.selectValue = this.selectDefault;
      },
      immediate: true
    },
    isAdvancedContentShow: {
      handler: function(val) {
        this.advancedContentShow = this.isAdvancedContentShow;
      },
      immediate: true
    }
  },
  methods: {
    deteRange(e) {
      this.$emit('deteRange', e);
    },
    // select选择器结果
    selectChange(e) {
      this.$emit('selectChange', e);
    },
    // 获取输入框内容
    getInput() {
      this.$emit('update:model', this.keyword);
      this.$emit('getInput', this.keyword);
    },
    // 搜索输入框条件
    search() {
      this.$emit('search', this.keyword);
    },
    // 导出
    exportExcel() {
      this.$emit('exportExcel');
    },
    // 新增
    add() {
      this.$emit('add');
    },
    // 清空input
    clearInput() {
      this.keyword = '';
      this.$emit('clearInput');
    },
    // 高级搜索
    advancedSearch() {
      this.advancedContentShow = !this.advancedContentShow;
      this.$emit('advancedSearch', this.advancedContentShow);
    }
  }
};
</script>

<style lang="scss" scoped>
.search_div {
  width: 261px !important;
  .search-item {
    width: 229px !important;

  }
  .search-input{
    ::v-deep .el-input__inner {
      border-right: none !important;
      border: 1px solid #dcdfe6;
      border-top-right-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    .el-input-group__append {
      padding-left: 0;
    }
  }
}
.input_focus .search-item {
  .el-input__inner {
    border-color: $main;
  }
}
.search-btn {
  top: 0px;
  right: 0px;
  height: 32px;
  background: $main;
  color: #ffffff;
  border-left: none;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
  &.disable{
border: 1px solid #dcdfe6;
  }
  &.allow{
  border: 1px solid $main;
  }
}
.filter-container {
  padding-bottom: 0px;
 .search-item {
    margin-right: 8px;
  }
 .filter-item {
    display: inline-table;
    vertical-align: baseline;
  }
}
.el-input__inner:focus {
  border-color: $main;
}
.el-input-group--append .el-input__inner,
.el-input-group__prepend {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.opera-area {
  > div {
    margin-right: 10px;
  }
}
</style>
